import { render, staticRenderFns } from "./ProviderPerformancePage.vue?vue&type=template&id=01d690ba&scoped=true"
import script from "./ProviderPerformancePage.vue?vue&type=script&lang=js"
export * from "./ProviderPerformancePage.vue?vue&type=script&lang=js"
import style0 from "./ProviderPerformancePage.vue?vue&type=style&index=0&id=01d690ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d690ba",
  null
  
)

export default component.exports